import { render, staticRenderFns } from "./SampleChart.vue?vue&type=template&id=0f93203c&scoped=true"
import script from "./SampleChart.vue?vue&type=script&lang=js"
export * from "./SampleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93203c",
  null
  
)

export default component.exports